import {
  addProps,
  addWrapper,
  CurriedUnchangedProps,
  flowMax,
  ValueOrFunctionOfProps,
} from 'ad-hok'
import { Helmet } from 'react-helmet-async'
import { isFunction } from 'lodash'

import { addTranslationHelpers } from 'utils/addTranslationHelpers'

type SetPageTitle = <TProps extends {}>(
  pageTitle?: ValueOrFunctionOfProps<string | null, TProps>
) => CurriedUnchangedProps<TProps>

export const setPageTitle: SetPageTitle = (pageTitle) =>
  flowMax(
    addTranslationHelpers,
    addProps((props) => {
      const suffix = isFunction(pageTitle) ? pageTitle(props) : pageTitle

      return {
        _title: suffix
          ? props.t('titleWithSuffix', { suffix })
          : props.t('title'),
      }
    }),
    addWrapper((render, { _title }) => (
      <>
        <Helmet>
          <title>{_title}</title>
          <meta property="og:title" content={_title} />
        </Helmet>
        {render()}
      </>
    ))
  )
